/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import { Box } from '@chakra-ui/core';
import { Calendar as BigCalendar } from 'react-big-calendar';

interface CalendarBaseProps {
  formats: any;
  localizer: any;

  events: any[];

  scrollToTime: Date;

  calendarCurrentView: string;

  hasAnyAllDayEvent: boolean;

  handleEventOfDate: any;
  handleSelect: any;
  handleEventType: any;
  handleNavigation: any;
  handleCalendarView: any;

  calendarComponents: any;

  calendarMessages: any;

  calendarNow: Date;

  showDualGutter: boolean;
}

export const CalendarBase = React.memo(
  ({
    formats,
    localizer,
    events,
    scrollToTime,
    calendarCurrentView,
    hasAnyAllDayEvent,
    handleEventOfDate,
    handleSelect,
    handleEventType,
    handleNavigation,
    handleCalendarView,
    calendarComponents,
    calendarMessages,
    calendarNow,
    showDualGutter,
  }: CalendarBaseProps) => {
    return (
      <Box
        p={2}
        sx={{
          '& .rbc-allday-cell': {
            display: hasAnyAllDayEvent ? 'unset' : 'none',
          },
        }}
        data-testid="CalendarView"
      >
        <BigCalendar
          formats={formats}
          localizer={localizer}
          selectable
          events={events}
          step={30}
          timeslots={2}
          scrollToTime={scrollToTime}
          defaultView="week"
          views={['month', 'week', 'day']}
          showAllEvents
          showMultiDayTimes
          onSelectEvent={handleEventOfDate}
          onSelectSlot={handleSelect}
          eventPropGetter={handleEventType}
          onNavigate={handleNavigation}
          components={calendarComponents}
          onView={handleCalendarView}
          className={`${calendarCurrentView}${showDualGutter ? ' dual-gutter-active' : ''}`}
          messages={calendarMessages}
          getNow={() => calendarNow}
        />
      </Box>
    );
  },
);

CalendarBase.displayName = 'CalendarBase';
